export default {
  usernameError:
    'Please check your details before continuing. This email address has already been used to register an account.',
  passwordError: 'Sorry, that password is incorrect.',
  userDisabledError:
    'This account has been disabled. If you have any questions or concerns you can contact us',
  genericRegisterError:
    'We are experiencing difficulties creating your account at the moment. Please try again later.',
  genericSignInError:
    'We are experiencing difficulties accessing your account at the moment. Please try again later.',
  sessionAuthErrorFromSignUp:
    'You have succesfully signed up but we are experiencing difficulties accessing your account at the moment. Please try signing in again later.',
  usernamePasswordError:
    'Sorry, either the email address or the password you entered does not correspond with any of our accounts.',
  passwordResetRequiredError:
    "We notice you haven't logged in for a while, for security reasons please ",
  apiUpdateError:
    'We are experiencing difficulties saving your changes at the moment. Please try again later.',
  apiGetError:
    'We are experiencing difficulties retrieving your preferences at the moment. Please try again later.',
  reCaptchaError: 'Please verify the ReCaptcha.',
  genericError: 'We are experiencing difficulties at the moment. Please try again later.',
};
